export const ITUNES_GENRES = [
  { id: 14, label: 'Pop' },
  { id: 17, label: 'Dance' },
  { id: 18, label: 'Hiphop / Rap' },
  { id: 15, label: 'R&B / Soul' },
  { id: 12, label: 'Latin' },
  { id: 6, label: 'Country' },
  { id: 7, label: 'Electronic' },
  { id: 20, label: 'Alternative' },
  { id: 21, label: 'Rock' },
  // { id: 1048, label: 'House' },
  // { id: 19, label: 'World' },
  // { id: 24, label: 'Reggae' },
  // { id: 11, label: 'Jazz' },
  // { id: 2, label: 'Blues' },
  // { id: 25, label: 'Easy Listening' },
  // { id: 1044, label: 'Breakbeat' },
  // { id: 1047, label: 'Hardcore' },
  // { id: 1050, label: 'Techno' },
  // { id: 1051, label: 'Trance' },
  // { id: 1046, label: 'Garage' },
  // { id: 1049, label: 'Jungle / Drum & Bass' },
]
